import React from 'react'

function FormButton(props) {
    return (
        <>
            <button className='opk-login-btn w-100 fw-bold fs-18 text-white' onClick={props.handleLogin} disabled={!!props.showLoading}>
                {props.showLoading ? (
                    <span
                        className='spinner-border spinner-border-sm inline-loading-spinner'
                        role='status'
                        aria-hidden='true'></span>
                ) : null}
                <span>{props.Text}</span>
            </button>
        </>
    )
}

export default FormButton